import AboutOne from "../components/AboutOne";
import Footer from "../components/Footer";

export default function About() {
  return (
    <div className="main_basket">
      <AboutOne />
      <Footer />
    </div>
  );
}
